import girl from 'shared/assets/img/speakers/girl.png';
import girlFull from 'shared/assets/img/speakers/girl2.png';
import girlStudent from 'shared/assets/img/speakers/girlStudent.png';
import girlStudentFull from 'shared/assets/img/speakers/girlStudent2.png';
import girlAdult from 'shared/assets/img/speakers/girlAdult.png';
import girlAdultFull from 'shared/assets/img/speakers/girlAdult2.png';
import boy from 'shared/assets/img/speakers/boy.png';
import boyFull from 'shared/assets/img/speakers/boy2.png';
import boyStudent from 'shared/assets/img/speakers/boyStudent.png';
import boyStudentFull from 'shared/assets/img/speakers/boyStudent2.png';
import boyAdult from 'shared/assets/img/speakers/boyAdult.png';
import boyAdultFull from 'shared/assets/img/speakers/boyAdult2.png';
import mother from 'shared/assets/img/speakers/mother.png';
import father from 'shared/assets/img/speakers/father.png';
import robot from 'shared/assets/img/speakers/robot.png';
import directorTsg from 'shared/assets/img/speakers/director-tsg.png';
import chief from 'shared/assets/img/speakers/chief.png';
import grownGirl from 'shared/assets/img/speakers/grownGirl.png';

export const speakerData: any = {
    w: {
        name: 'Анна',
        img: girl,
        imgFull: girlFull,
        imgStudent: girlStudent,
        imgStudentFull: girlStudentFull,
        imgAdult: girlAdult,
        imgAdultFull: girlAdultFull,
    },
    m: {
        name: 'Макс',
        img: boy,
        imgFull: boyFull,
        imgStudent: boyStudent,
        imgStudentFull: boyStudentFull,
        imgAdult: boyAdult,
        imgAdultFull: boyAdultFull,
    },
    mother: {
        name: 'Мама',
        img: mother,
        imgFull: mother,
    },
    father: {
        name: 'Папа',
        img: father,
        imgFull: father,
    },
    robot: {
        name: 'Помощник',
        img: robot,
        imgFull: robot,
    },
    directorTsg: {
        name: 'Глава ТСЖ',
        img: directorTsg,
        imgFull: directorTsg,
    },
    chief: {
        name: 'Начальник',
        img: chief,
        imgFull: chief,
    },
    grownGirl: {
        name: 'Аня',
        img: grownGirl,
    },
};
